import { setupNumeralFilters } from './number';
import { setupEmployeeFilters } from './employee';
/**
 * Setup Plugins for the Vue instance
 * @param {VueConstructor<Vue>} instance
 */
export function setupFilters (instance) {

  setupNumeralFilters(instance);

  setupEmployeeFilters(instance);

}
